import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import TourList from "./pages/TourList";
import TourEditor from "./pages/TourEditor";
import PublicTourView from "./pages/PublicTourView";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <nav className="navbar">
          <div className="container">
            <Link to="/" className="logo">
              <h1>Tour Builder</h1>
            </Link>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<TourList />} />
            <Route path="/tours/:id/edit" element={<TourEditor />} />
            <Route path="/tour/:shareId" element={<PublicTourView />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
